import { render, staticRenderFns } from "./AuraSetting.vue?vue&type=template&id=9a291250&scoped=true"
import script from "./AuraSetting.vue?vue&type=script&lang=ts"
export * from "./AuraSetting.vue?vue&type=script&lang=ts"
import style0 from "./AuraSetting.vue?vue&type=style&index=0&id=9a291250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a291250",
  null
  
)

export default component.exports